import {css, keyframes} from 'styled-components';

export const qrShake = keyframes`
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-7px); }
    75% { transform: translateX(7px); }
`;

export const qrShakeOnScan = css`
    animation: ${qrShake} .5s ease 0s 2;
`;
